import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTopOnNavigate() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    // Force scroll to top on page change
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname, search]); // runs on every navigation

  return null;
}
